export default __webpack_public_path__ + "images/conbini-color-55b76a.svg";